<!-- 论文节点提交表单 -->
<template>
  <el-form ref="form" class="form-wrap" :rules="rules" :model="ruleForm" label-width="120px" label-position="left">
    <el-form-item label="论文中文题目" prop="title">
      <el-input v-model="ruleForm.title" :disabled="allowSubmit === 0" clearable placeholder="请输入论文中文题目" />
    </el-form-item>
    <el-form-item label="论文英文题目" prop="en_title">
      <el-input v-model="ruleForm.en_title" :disabled="allowSubmit === 0" clearable placeholder="请输入论文英文题目" />
    </el-form-item>
    <!-- 开题，初稿，终稿 ==> 研究方向 -->
    <el-form-item v-if="![''].includes(node)" label="研究方向" prop="direction_id">
      <el-radio-group v-model="ruleForm.direction_id" :disabled="allowSubmit === 0" size="small">
        <el-radio-button v-for="item in directionList" :key="item.id" :label="item.id" :value="item.id" button>
          {{ item.title }}
        </el-radio-button>
      </el-radio-group>
      <el-input v-if="ruleForm.direction_id === -1" v-model="ruleForm.other_direction" placeholder="请输入研究方向"></el-input>
    </el-form-item>
    <el-form-item
      v-if="['end_draft'].includes(node)"
      label="自查重率"
      prop="[extra_content][duplication_rate]"
      :rules="{ required: true, message: '请输入自查重率', trigger: 'blur' }"
    >
      <el-input-number v-model="ruleForm.extra_content.duplication_rate" type="number" :min="0" :max="100" :precision="2"></el-input-number>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;单位：%</span>
    </el-form-item>
    <el-form-item
      v-if="node === 'end_draft'"
      ref="duplicationFileUpload"
      label="自查重报告"
      prop="[extra_content][duplication_file]"
      :rules="{ required: true, message: '请上传自查重报告', trigger: 'blur' }"
    >
      <upload-component
        :is-disabled="allowSubmit === 0"
        accept-type=".pdf"
        :file-list="ruleForm.extra_content.duplication_file"
        :custom-file-name="customFileName3"
        :max-size="15"
      ></upload-component>
    </el-form-item>
    <el-form-item ref="fileUpload" :label="labelObject[processNode]" prop="file">
      <upload-component
        :is-disabled="allowSubmit === 0"
        :accept-type="configInfo.fileType.length > 0 ? configInfo.fileType.map(item => '.' + item).join(',') : '.pdf'"
        :file-list="ruleForm.file"
        :custom-file-name="customFileName"
        :max-size="15"
      ></upload-component>
    </el-form-item>
    <el-form-item
      v-if="configInfo.is_confirmation === 1"
      ref="confirmFileUpload"
      label="导师确认单"
      prop="[extra_content][confirmation_file]"
      :rules="{ required: true, message: '请上传导师确认单', trigger: 'blur' }"
    >
      <upload-component
        :is-disabled="allowSubmit === 0"
        accept-type=".pdf,.doc,.docx,.jpg,.jpeg,.png"
        :file-list="ruleForm.extra_content.confirmation_file"
        :custom-file-name="customFileName2"
        :max-size="15"
      ></upload-component>
    </el-form-item>
    <div class="submit-item">
      <div class="btn-group">
        <el-button :disabled="allowSubmit === 0" size="small" @click="submitFn(1)">保存</el-button>
        <el-button :disabled="allowSubmit === 0" size="small" type="primary" @click="submitFn(2)">提交</el-button>
      </div>
      <p>
        <template v-if="processNode !== 'review_draft'">
          提交状态：{{ ruleForm.is_submit === 1 ? '已提交' : '未提交' }}
          <template v-if="ruleForm.is_submit && ruleForm.submit_time">
            <span style="color: #666">（提交时间：{{ timeFormat(ruleForm.submit_time * 1000) }}）</span>
          </template>
        </template>
      </p>
    </div>
  </el-form>
</template>

<script setup>
import { computed, onBeforeMount, reactive, ref } from 'vue'
import UploadComponent from '@/components/UploadComponent'
import API from '@/api'
import { Message, MessageBox } from 'element-ui'
import { timeFormat } from '@/utils'
import Store from '@/store'
import Router from '@/router'
const routeInfo = ref(Router.currentRoute)

const props = defineProps({
  values: {
    type: Object,
    default: () => {
      return {}
    }
  },
  // eslint-disable-next-line vue/require-default-prop
  batchInfo: {
    type: Object
  },
  // eslint-disable-next-line vue/require-default-prop
  processNode: {
    type: String
  },
  // eslint-disable-next-line vue/require-default-prop
  isSubmit: {
    type: Number
  },
  // 子节点的属性名
  childNode: {
    type: String,
    default: ''
  }
})

const nodeName = computed(() => {
  return props.childNode
})

const labelObject = {
  opening_defense: '开题报告',
  first_draft: '初稿',
  end_draft: '终稿',
  blind_draft: '盲审稿',
  review_draft: '评阅稿'
}

const node = computed(() => {
  return props.processNode
})

const allowSubmit = computed(() => {
  return props.isSubmit
})

// 表单数据
const ruleForm = computed(() => {
  return props.values
})

// 批次信息
const batch = computed(() => {
  return props.batchInfo
})

const form = ref()

function direction(rule, value, callback) {
  if (!value) {
    callback(new Error('请选择研究方向'))
  } else {
    if (value === -1 && !ruleForm.value.other_direction) {
      callback(new Error('请输入其他研究方向'))
    } else {
      callback()
    }
  }
}

const rules = ref({
  title: { required: true, message: '请输入论文中文题目', trigger: 'blur' },
  en_title: { required: true, message: '请输入论文英文题目', trigger: 'blur' },
  direction_id: { required: true, validator: direction, trigger: 'blur' },
  file: { required: true, message: '请上传文件', trigger: 'blur' }
})

const directionList = ref([])
// 获取研究方向
function getDirections() {
  API.MBAThesisDirectionList().then(res => {
    if (+res.code === 200) {
      directionList.value = [
        ...res.data.map(item => {
          return { title: item.title, id: +item.id }
        }),
        { title: '其他', id: -1 }
      ]
    } else {
      Message.error(res.msg)
    }
  })
}

onBeforeMount(() => {
  getDirections()
})

// 节点配置信息
const configInfo = reactive({
  template: [],
  fileType: [],
  is_confirmation: 0
})

onBeforeMount(() => {
  // 获取节点配置
  for (const key in configInfo) {
    if (Object.hasOwnProperty.call(configInfo, key)) {
      if (nodeName.value) {
        configInfo[key] = batch.value.content[nodeName.value][key]
      } else {
        configInfo[key] = batch.value.content[key]
      }
    }
  }
})

// 提交
// operate：1=>保存，2=>提交
async function submitFn(operate) {
  await form.value.validate(valid => {
    if (valid) {
      if (operate === 2) {
        MessageBox.confirm('提交后不支持二次修改，请确认是否继续？', '提示')
          .then(() => {
            saveFn(operate)
          })
          .catch(() => {})
      } else {
        saveFn(operate)
      }
    }
  })
}

function saveFn(operate) {
  // 处理文件
  const file = ruleForm.value.file.map(item => {
    return {
      url: item.url,
      name: item.name,
      size: item.size,
      label: labelObject[node.value],
      ctime: item.ctime || timeFormat(+new Date())
    }
  })

  // 处理导师确认单
  const confirmation_file =
    ruleForm.value.extra_content.confirmation_file &&
    ruleForm.value.extra_content.confirmation_file.map(item => {
      return {
        url: item.url,
        name: item.name,
        size: item.size,
        label: labelObject[node.value],
        ctime: item.ctime || timeFormat(+new Date())
      }
    })

  const duplication_file =
    ruleForm.value.extra_content.duplication_file &&
    ruleForm.value.extra_content.duplication_file.map(item => {
      return {
        url: item.url,
        name: item.name,
        size: item.size,
        label: labelObject[node.value],
        ctime: item.ctime || timeFormat(+new Date())
      }
    })

  // 处理提交表单
  const submitForm = {
    operate,
    children: nodeName.value,
    ThesisPaper: {
      type: node.value,
      title: ruleForm.value.title,
      en_title: ruleForm.value.en_title,
      direction_id: ruleForm.value.direction_id,
      other_direction: ruleForm.value.other_direction,
      file,
      extra_content: {
        confirmation_file: confirmation_file || [],
        duplication_rate: ruleForm.value.extra_content.duplication_rate || '',
        duplication_file: duplication_file || []
      }
    }
  }

  // 提交
  API.MBAThesisProcessSubmit(submitForm)
    .then(res => {
      if (+res.code === 200) {
        Message.success(res.msg)
        updateHandle()
      } else {
        Message.error(res.msg)
      }
    })
    .catch(err => {
      console.error(err)
    })
}

const userInfo = computed(() => {
  return Store.state.user.userInfo
})
// 自定义文件名
const customFileName = computed(() => {
  return `${userInfo.value.className}-${userInfo.value.idnumber}-${userInfo.value.name}-${
    routeInfo.value.meta.children ? routeInfo.value.meta.children[nodeName.value].title : routeInfo.value.meta.title
  }`
})
const customFileName2 = computed(() => {
  return `导师确认单-${userInfo.value.className}-${userInfo.value.idnumber}-${userInfo.value.name}-${
    routeInfo.value.meta.children ? routeInfo.value.meta.children[nodeName.value].title : routeInfo.value.meta.title
  }`
})
const customFileName3 = computed(() => {
  return `自查重报告-${userInfo.value.className}-${userInfo.value.idnumber}-${userInfo.value.name}-${
    routeInfo.value.meta.children ? routeInfo.value.meta.children[nodeName.value].title : routeInfo.value.meta.title
  }`
})

const emit = defineEmits(['updateFn'])
function updateHandle() {
  emit('updateFn')
}
</script>

<style lang="scss" scoped>
.form-wrap {
  margin: 30px 0;

  .el-radio-button {
    margin-right: 15px;
    margin-bottom: 15px;

    &.is-active {
      :deep(.el-radio-button__inner) {
        border-left: 0;
      }
    }

    :deep(.el-radio-button__inner) {
      border-left: 1px solid #dcdfe6;
    }
  }
}
</style>
